export class Valuacion {
    public idValuacion: number;
    public fechaValuacion: Date;
    public fechaAceptacion?: Date;
    public idFolio: number;
    public idEmpleado?: number;
    public ordenServicio: string;
    public status: string;
    public tipoUnidad: string;
    public marca: string;
    public modelo: string;
    public serie: string;
    public valorComercial: number;
    public comentario: string;
}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/model/classes/valuacion.ts